<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'

const emits = defineEmits([
    'showGlobalScoreAverage',
    'showReviewPopUp',
    'updateSection'
])

defineProps({
    isContainedInDrawer: { type: Boolean, default: true }
})

const poolStore = usePoolStore()
</script>

<template>
    <div class="flex items-center" :class="{ 'mb-4': isContainedInDrawer }">
        <PoolRating
            class="text-4xl cursor-pointer"
            :rating="poolStore.getRating"
            :rating-count="poolStore.getRatingCount"
            :display-rating-as-text="!!poolStore.getRatingCount"
            display-rating-count
            @click="
                isContainedInDrawer
                    ? emits('updateSection', 'reviews')
                    : emits('showGlobalScoreAverage')
            "
        />
        <IconInfoCircle
            class="ml-1.5 cursor-pointer text-gray-l-500 size-4"
            :is-solid="false"
            @click="emits('showReviewPopUp', true)"
        />
    </div>
</template>
